// extracted by mini-css-extract-plugin
module.exports = {"root":"visually-hidden_root__DXQEq"};